function randomId() {
    return "mantine-".concat(Math.random().toString(36).slice(2, 11));
}
export { randomId }; //# sourceMappingURL=random-id.js.map
